import { values } from 'lodash/fp';

import ADD_ONS from '../../../../../src/client/pages/add-ons/constants';
import CashBoostClaimPage from '../../../../../src/client/pages/add-ons/cash-boost/claim';
import getStaticPathsForAddOns from '../../utils/get-static-paths-for-add-ons';

const ClaimPage = () => <CashBoostClaimPage />;

export const getStaticPaths = () => getStaticPathsForAddOns(values(ADD_ONS));

export const getStaticProps = async () => ({
  props: {},
});

export default ClaimPage;
